import * as defaultToken from './tokens';

export default {
  name: 'Default Theme',
  ...defaultToken,
};
